module.exports = __webpack_public_path__ + "fonts/RundigsburgBold.134bea4.woff";